import { formatToMaxFourDigits } from '@flexo/general';
import React from 'react';

const InformationCardContentCurlyTrees = ({ description, cardValue, t }) => {
  return (
    <div>
      <span>
        {t(description.line_1)}
        <br />
        {t(description.line_2, { trees: cardValue?.value ? formatToMaxFourDigits(cardValue?.value) : '-.-' })}
      </span>
    </div>
  );
};

export default InformationCardContentCurlyTrees; 